import { strings } from "@/I18n";
import ButtonWithLoader from "@/v2/components/ButtonWithLoader";
import { Button } from "@/v2/ui/primitives/button";

interface ModalFooterButtonsProps {
  onCancel: () => void;
  onSubmit?: () => void;
  formId?: string;
  cancelLabel?: string;
  submitLabel?: string;
  isLoading?: boolean;
  showSubmit?: boolean;
}

export function ModalFooterButtons({
  onCancel,
  onSubmit,
  formId,
  cancelLabel,
  submitLabel,
  isLoading = false,
  showSubmit = true,
}: ModalFooterButtonsProps): JSX.Element {
  const submitButton = onSubmit ? (
    <Button
      type="button"
      onClick={onSubmit}
      className="tw-flex-1 sm:tw-flex-none"
    >
      {submitLabel || strings("descriptions.save")}
    </Button>
  ) : (
    <Button type="submit" form={formId} className="tw-flex-1 sm:tw-flex-none">
      {submitLabel || strings("descriptions.save")}
    </Button>
  );

  return (
    <>
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="tw-flex-1 sm:tw-flex-none"
      >
        {cancelLabel || strings("descriptions.discard")}
      </Button>
      {showSubmit &&
        (isLoading ? (
          <ButtonWithLoader
            text={submitLabel || strings("descriptions.save")}
            isLoading={true}
          />
        ) : (
          submitButton
        ))}
    </>
  );
}
